import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../components/layout/PublicHeader';
import PublicFooter from '../components/layout/PublicFooter';

const AboutUs: React.FC = () => {
  // Function to go back to the previous page
  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="flex flex-col min-h-screen bg-slate-50">
      {/* Header */}
      <PublicHeader />

      {/* Main Content */}
      <main className="flex-grow container mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8">
          <h1 className="text-3xl font-bold text-slate-900 mb-8 text-center">درباره ما</h1>
          
          <div className="max-w-4xl mx-auto">
            <div className="mb-8 text-center">
              <img src="/assets/img/logoRazi.png" alt="آزمایشگاه رازی" className="h-40 mx-auto mb-6" />
              <h2 className="text-2xl font-bold text-slate-800 mb-4">آزمایشگاه تشخیص طبی، آسیب شناسی و ژنتیک رازی رشت</h2>
              <p className="text-lg text-slate-600">ارائه دهنده خدمات آزمایشگاهی با بالاترین کیفیت</p>
            </div>
            
            <div className="space-y-6 text-slate-700 leading-relaxed text-justify">
              <p>
                آزمایشگاه پاتوبیولوژی رازی رشت در سال 1365 افتتاح گردیده ؛ بیش از35سال سابقه ی فعالیت از زمان تاسیس به عنوان یکی از آزمایشگاههای برتر شمال کشور فعالیت می نماید. این آزمایشگاه با اختصاص فضایی نزدیک به 2200 متر مربع با طراحی مدرن در چند طبقه با بخش های کلینیکال پاتولوژی ، آناتومیکال پاتولوژی ، مولکولار پاتولوژی و ژنتیک پزشکی با پرسنل متعهد و متخصص و بکارگیری تجهیزات مدرن و بروز بر اساس پروتکل ها و استاندارد های روز جهان در حال گسترش فعالیت های خود بوده و مورد اعتماد مردم ، جامعه ی پزشکان و برند های مطرح کشور می باشد.
              </p>
              
              <h3 className="text-xl font-bold text-slate-800 mt-8">چشم انداز</h3>
              <p>
                تبدیل شدن به موفق ترین و معتبر ترین آزمایشگاه تشخیص طبی ایران
              </p>
              
              <h3 className="text-xl font-bold text-slate-800 mt-8">خط مشی کیفیت</h3>
              <p>
                با اعتقاد به اهمیت متعهدانه کار در آزمایشگاه پزشکی ، ما در آزمایشگاه رازی همواره می کوشیم تا با دمیدن روح " تعهد " و ارتقای سطح دانش و آگاهی در تمامی مدیران و کارکنان آزمایشگاه نسبت به حرفه پزشکی ، مردم و نیز شهری که در آن زندگی می کنیم علاقه ، وفاداری و تعهد خود را به اثبات برسانیم.
              </p>
              
              <h3 className="text-xl font-bold text-slate-800 mt-8">آزمایشگاه مرجع</h3>
              <p>
                در حال حاضر آزمایشگاه رازی به عنوان مرجع 55 آزمایشگاه در سطح استان می باشد که تست های تخصصی کلینیکال پاتولوژی ، آناتومیکال پاتولوژی و ژنتیک خود را به این آزمایشگاه ارسال می نمایند.
              </p>
              <p>
                همچنین این آزمایشگاه از طرف مرکز بهداشت استان گیلان به عنوان آزمایشگاه مرجع برای غربالگری تست های تیروئیدی بدو تولد و نیز طرح غربالگری تالاسمی انتخاب شده است.
              </p>
              
              <h3 className="text-xl font-bold text-slate-800 mt-8">اهداف کلی آزمایشگاه</h3>
              <ul className="list-disc pr-6 mt-4 space-y-2">
                <li>ارتقای کیفیت خدمات آزمایشگاهی به گونه ای که همواره معیار و شاخصی برای ارزیابی کیفیت باشیم.</li>
                <li>افزایش رضایتمندی افرادی که به گونه ای با این مرکز در ارتباط هستند ، به شیوه ای که توان خود را در برطرف کردن نیازهای آنان مستمراً افزایش دهیم.</li>
                <li>تکیه دائم بر اصول اخلاقی ، چه اخلاق عمومی و چه اخلاق حرفه ای</li>
                <li>بکارگیری کارکنان مجرب ، آموزش دیده و نیز ارتقا و باز آموزی دوره ای آنان</li>
                <li>بهبود مداوم و مستمر کیفیت تحقق اهداف فوق با استقرارسیستم مدیریت کیفیت همواره مدنظر مدیریت و تمامی کارکنان آزمایشگاه رازی بوده و با تمام توان ، در راستای تحقق اهداف قدم بر می دارد</li>
              </ul>
            </div>
            
            <div className="mt-12">
              <h3 className="text-xl font-bold text-slate-800 mb-4">خدمات ما</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-blue-50 p-5 rounded-lg">
                  <h4 className="font-bold text-blue-800 mb-2">آزمایش‌های تشخیص طبی</h4>
                  <p className="text-slate-700">انواع آزمایش‌های خون، ادرار، مدفوع و سایر آزمایش‌های رایج پزشکی</p>
                </div>
                <div className="bg-blue-50 p-5 rounded-lg">
                  <h4 className="font-bold text-blue-800 mb-2">آزمایش‌های تخصصی</h4>
                  <p className="text-slate-700">آزمایش‌های هورمونی، ایمونولوژی، سرولوژی و تستهای تخصصی</p>
                </div>
                <div className="bg-blue-50 p-5 rounded-lg">
                  <h4 className="font-bold text-blue-800 mb-2">آزمایش‌های ژنتیکی</h4>
                  <p className="text-slate-700">تست‌های تشخیص بیماری‌های ژنتیکی، غربالگری و تشخیص قبل از تولد</p>
                </div>
                <div className="bg-blue-50 p-5 rounded-lg">
                  <h4 className="font-bold text-blue-800 mb-2">آسیب شناسی</h4>
                  <p className="text-slate-700">بررسی نمونه‌های بافتی و سلولی برای تشخیص بیماری‌ها</p>
                </div>
              </div>
            </div>
            
            <div className="mt-12 text-center">
              <button 
                onClick={goBack}
                className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                بازگشت
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <PublicFooter />
    </div>
  );
};

export default AboutUs; 